import { useTranslation } from "react-i18next";
import { Alert, Button, notification } from "antd";
import { observer } from "mobx-react-lite";

import { deleteAutopayment } from "../../api/payment";
import { userStore } from "../../stores/userStore";
import { sendCounterEvent } from "../../utils/counterService";
import { formatDate } from "../../utils/date";
import { getSubscriptionPlanName } from "../../utils/subscriptionPlan";
import { usePendingAction } from "../../utils/usePendingAction";
import { SubscriptionRestrictions } from "./SubscriptionRestrictions";

export const SubscriptionCancellation = observer(
  function SubscriptionCancellation() {
    const { t, i18n } = useTranslation();
    const sub = userStore.subscription;
    const { pending: processing, run } = usePendingAction();
    const onConfirm = () =>
      run(async () => {
        try {
          sendCounterEvent("cancel-subscription");
          if (sub?.autopayment) await deleteAutopayment();
          window.location.href = "/subscription?scenario=cancellation";
        } catch {
          notification.error({
            message: t("errors.shared.common_error"),
            placement: "topRight",
          });
        }
      });
    const locale = i18n.language;
    const currentPlan = sub?.plan?.toLowerCase() ?? "lemon";

    return (
      <div className="subscription-checkout">
        <div className="subscription-checkout__cancel-info">
          <Alert
            type="info"
            description={
              <span
                dangerouslySetInnerHTML={{
                  __html: t(
                    "subscription.canceledSubscriptionWillBeActiveUntil",
                    {
                      plan: getSubscriptionPlanName(currentPlan),
                      date: sub?.expire_at
                        ? formatDate(sub.expire_at, locale)
                        : "",
                    },
                  ),
                }}
              />
            }
          />
          <SubscriptionRestrictions variant="lemon" />
        </div>
        <div className="subscription-checkout__actions">
          <Button type="primary" block loading={processing} onClick={onConfirm}>
            {t("subscription.cancelSubscription")}
          </Button>
          <Button block href="/subscription">
            {t("app.goBack", { defaultValue: "Go back" })}
          </Button>
        </div>
      </div>
    );
  },
);
